import React from 'react';

const LoadingIndicator = () => (
  <i className="fa fa-spinner fa-pulse fa-fw"></i>
);

export default  LoadingIndicator;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/LoadingIndicator.jsx